// Box weight mapping in pounds for display and calculations
export const BOX_WEIGHTS = {
  "One Unit": 1,
  "Small Box": 5,
  "Large Box": 15,
  "XL Box": 25,
  "Bulk Box": 40
};

// Get display text for box size with weight
export const getBoxSizeDisplay = (sizeName) => {
  const weight = BOX_WEIGHTS[sizeName];
  if (weight) {
    return `${sizeName} - ${weight} lbs`;
  }
  return sizeName;
};

// Helper function to calculate box price based on weight and per-pound price
export const calculateBoxPrice = (weight, perPoundPrice) => {
  return weight * perPoundPrice;
};

// Helper function to get default box size (Small Box or first available)
export const getDefaultBoxSize = (sizes) => {
  if (!sizes || sizes.length === 0) return null;

  // Try to find Small Box first, otherwise return the first available size
  const smallBox = sizes.find(size => size.name === "Small Box");
  return smallBox || sizes[0];
};

// Calculate total price for multiple boxes
export const calculateTotalBoxPrice = (weight, perPoundPrice, quantity) => {
  const boxPrice = calculateBoxPrice(weight, perPoundPrice);
  return boxPrice * quantity;
};

// Get box size information for display
export const getBoxSizeInfo = (sizeName) => {
  const weight = BOX_WEIGHTS[sizeName];
  return {
    name: sizeName,
    weight: weight,
    displayText: weight ? `${sizeName} (${weight} lbs)` : sizeName
  };
};

// Validate if a box size is supported
export const isValidBoxSize = (sizeName) => {
  return Object.keys(BOX_WEIGHTS).includes(sizeName);
};